import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/bg/501/',
    component: ComponentCreator('/bg/501/', '917'),
    exact: true
  },
  {
    path: '/bg/articles/',
    component: ComponentCreator('/bg/articles/', 'b58'),
    exact: true
  },
  {
    path: '/bg/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/bg/articles/2024/07/09/diskusija-lj-nj-cyrl/', 'e7f'),
    exact: true
  },
  {
    path: '/bg/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/bg/articles/2024/07/09/diskusija-lj-nj/', 'e41'),
    exact: true
  },
  {
    path: '/bg/articles/archive/',
    component: ComponentCreator('/bg/articles/archive/', 'cb4'),
    exact: true
  },
  {
    path: '/bg/articles/authors/',
    component: ComponentCreator('/bg/articles/authors/', 'efa'),
    exact: true
  },
  {
    path: '/bg/search/',
    component: ComponentCreator('/bg/search/', '524'),
    exact: true
  },
  {
    path: '/bg/',
    component: ComponentCreator('/bg/', 'af0'),
    exact: true
  },
  {
    path: '/bg/',
    component: ComponentCreator('/bg/', '76f'),
    routes: [
      {
        path: '/bg/',
        component: ComponentCreator('/bg/', '145'),
        routes: [
          {
            path: '/bg/tags/',
            component: ComponentCreator('/bg/tags/', '7f1'),
            exact: true
          },
          {
            path: '/bg/tags/comparative/',
            component: ComponentCreator('/bg/tags/comparative/', 'e63'),
            exact: true
          },
          {
            path: '/bg/tags/grammar/',
            component: ComponentCreator('/bg/tags/grammar/', 'b77'),
            exact: true
          },
          {
            path: '/bg/tags/interslavic/',
            component: ComponentCreator('/bg/tags/interslavic/', 'ae3'),
            exact: true
          },
          {
            path: '/bg/tags/language-learning/',
            component: ComponentCreator('/bg/tags/language-learning/', 'd59'),
            exact: true
          },
          {
            path: '/bg/tags/linguistics/',
            component: ComponentCreator('/bg/tags/linguistics/', 'b11'),
            exact: true
          },
          {
            path: '/bg/tags/personal-pronouns/',
            component: ComponentCreator('/bg/tags/personal-pronouns/', '755'),
            exact: true
          },
          {
            path: '/bg/tags/pronouns/',
            component: ComponentCreator('/bg/tags/pronouns/', '935'),
            exact: true
          },
          {
            path: '/bg/tags/slavic-languages/',
            component: ComponentCreator('/bg/tags/slavic-languages/', '36c'),
            exact: true
          },
          {
            path: '/bg/tags/граматика/',
            component: ComponentCreator('/bg/tags/граматика/', 'f7b'),
            exact: true
          },
          {
            path: '/bg/tags/изучаване-на-език/',
            component: ComponentCreator('/bg/tags/изучаване-на-език/', 'a6f'),
            exact: true
          },
          {
            path: '/bg/tags/междуславянски-език/',
            component: ComponentCreator('/bg/tags/междуславянски-език/', '9db'),
            exact: true
          },
          {
            path: '/bg/tags/междуславянски/',
            component: ComponentCreator('/bg/tags/междуславянски/', 'fa9'),
            exact: true
          },
          {
            path: '/bg/tags/местоимения/',
            component: ComponentCreator('/bg/tags/местоимения/', '179'),
            exact: true
          },
          {
            path: '/bg/tags/сравнение-на-езици/',
            component: ComponentCreator('/bg/tags/сравнение-на-езици/', 'acc'),
            exact: true
          },
          {
            path: '/bg/',
            component: ComponentCreator('/bg/', '353'),
            routes: [
              {
                path: '/bg/learn/faq/',
                component: ComponentCreator('/bg/learn/faq/', '5eb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/grammar/',
                component: ComponentCreator('/bg/learn/grammar/', '901'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/grammar/adjectives/',
                component: ComponentCreator('/bg/learn/grammar/adjectives/', '535'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/grammar/conjunctions/',
                component: ComponentCreator('/bg/learn/grammar/conjunctions/', 'd0d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/grammar/nouns/',
                component: ComponentCreator('/bg/learn/grammar/nouns/', 'cac'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/grammar/numerals/',
                component: ComponentCreator('/bg/learn/grammar/numerals/', '71a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/grammar/prepositions/',
                component: ComponentCreator('/bg/learn/grammar/prepositions/', 'e22'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/grammar/pronouns/',
                component: ComponentCreator('/bg/learn/grammar/pronouns/', 'ab3'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/grammar/syntax/',
                component: ComponentCreator('/bg/learn/grammar/syntax/', '6d9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/grammar/verbs/',
                component: ComponentCreator('/bg/learn/grammar/verbs/', 'fe2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/introduction/',
                component: ComponentCreator('/bg/learn/introduction/', 'dc5'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/bg/learn/misc/constructed-slavic-languages/', 'ab5'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/misc/design-criteria/',
                component: ComponentCreator('/bg/learn/misc/design-criteria/', 'bed'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/misc/history/',
                component: ComponentCreator('/bg/learn/misc/history/', '6e9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/misc/language-comparison/',
                component: ComponentCreator('/bg/learn/misc/language-comparison/', '645'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/misc/numbers-1-10/',
                component: ComponentCreator('/bg/learn/misc/numbers-1-10/', 'ec1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/bg/learn/misc/pan-slavic-relay/', 'a67'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/misc/personal-pronouns/',
                component: ComponentCreator('/bg/learn/misc/personal-pronouns/', '7d6'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/orthography/',
                component: ComponentCreator('/bg/learn/orthography/', '014'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/phonology/',
                component: ComponentCreator('/bg/learn/phonology/', '600'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/pronunciation/',
                component: ComponentCreator('/bg/learn/pronunciation/', '2ba'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/simple-grammar/',
                component: ComponentCreator('/bg/learn/simple-grammar/', '503'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/simple-grammar/level-1/',
                component: ComponentCreator('/bg/learn/simple-grammar/level-1/', '9c8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/simple-grammar/level-2/',
                component: ComponentCreator('/bg/learn/simple-grammar/level-2/', '6b7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/vocabulary/derivation/',
                component: ComponentCreator('/bg/learn/vocabulary/derivation/', 'fb8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/bg/learn/vocabulary/flavourisation/', '1b8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/learn/vocabulary/word-formation/',
                component: ComponentCreator('/bg/learn/vocabulary/word-formation/', '952'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/bg/resources/',
                component: ComponentCreator('/bg/resources/', '0cb'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/bg/resources/applets/',
                component: ComponentCreator('/bg/resources/applets/', 'f9b'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/bg/resources/applets/intelligibility/',
                component: ComponentCreator('/bg/resources/applets/intelligibility/', '4ec'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/bg/resources/applets/transliterator/',
                component: ComponentCreator('/bg/resources/applets/transliterator/', '7f2'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/bg/resources/keyboards/',
                component: ComponentCreator('/bg/resources/keyboards/', 'd95'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
